<div class="menu-crud-mood-wrapper">
	<div id="MoodMatrixOuter" class="mood-matrix-outer">
		<div class="scroll-space">
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
		</div>
		<div class="mood-matrix-wrapper">
			@for (
					grp of [0, 1, 3, 2]; track grp) {
				<div class="mood-matrix-quadrant-outer" [ngClass]="grp === 0 || grp === 3 ? 'flex-row-reverse' : 'flex-row'">
					@for (
							r of [0, 1, 2, 3, 4, 5]; track r) {
						<div class="mood-matrix-quadrant-wrapper" [ngClass]="grp === 0 || grp === 1 ? 'flex-col-reverse' : 'flex-col'">
							@for (
									term of MoodMatrix[grp][r]; track term; let
									i = $index) {
								<div class="mood-matrix-cell" [ngClass]="{'mood-matrix-cell-active': svcMenuCrudMood.selected.includes(term)}" (click)="toggleActiveItem(term)">
									<div class="mood-matrix-cell-term">{{term}}</div>
								</div>
							}
						</div>
					}
				</div>
			}
		</div>
		<!--		<div class="scroll-space"></div>-->
	</div>

	<!--<div class="menu-crud-mood-form">
		&lt;!&ndash;		<div class="flex-1 h-full flex flex-col divide-y divide-white/25 overflow-y-scroll">&ndash;&gt;
		&lt;!&ndash;			@for (row of recordRowsLogs; track row.uuid) {&ndash;&gt;
		&lt;!&ndash;				<app-table-row-wrapper [id]="row.uuid" hideIcon [row]="row"></app-table-row-wrapper>&ndash;&gt;
		&lt;!&ndash;			}&ndash;&gt;
		&lt;!&ndash;		</div>&ndash;&gt;
		<div class="form-inner">
			<div OnHold (onHold)="addRecords()" class="inline-button">
				Add Records
			</div>
			<div class="date-input-wrapper">
				&lt;!&ndash;				<div class="date-input-value">{{dateInputObject | date: 'HH:mm'}}</div>&ndash;&gt;
				&lt;!&ndash;				<input (ngModelChange)="updateDateFormats($event)" [(ngModel)]="dateInputString" class="date-input" id="DateInput" type="datetime-local"/>&ndash;&gt;
			</div>
		</div>
	</div>-->
</div>
